import { eSigningAppointmentStatus } from './eSigningAppointmentStatus';
import { eSigningMethod } from './eSigningMethod';
import { ISigningAppointmentResponse } from './ISigningAppointmentResponse';
import {
  getStatusOptions,
  filterDssAttorneyStatusOptions,
  eSigningAppointmentConfirmationStatus,
  ISigningAppointmentStatusResponse,
} from './ISigningAppointmentStatusResponse';

export const computeStatusOptions = (
  signingStatuses: ISigningAppointmentStatusResponse[],
  appointmentFromPath?: ISigningAppointmentResponse
) => {
  const results = getStatusOptions(signingStatuses).filter((status) => {
    return (
      appointmentFromPath?.signingMethod !== eSigningMethod.notaryOnly ||
      status.value === eSigningAppointmentStatus.Cancelled
    );
  });

  const isDssAttorney =
    appointmentFromPath?.signingMethod === eSigningMethod.attorney &&
    (appointmentFromPath?.isDigitalScheduling || appointmentFromPath?.isDigitalSchedulingDraft);

  if (isDssAttorney) {
    return filterDssAttorneyStatusOptions(
      results,
      appointmentFromPath?.isDigitalSchedulingDraft,
      appointmentFromPath?.isDigitalSchedulingConfirmed,
      appointmentFromPath?.status as eSigningAppointmentConfirmationStatus
    );
  }

  return results;
};
